import React from "react";
import { Link } from "react-router-dom";
// import "./Newsletter.css"
function Newsletter() {
  return (
    <div>
      <div className=" px-2 w-full h-screen bg-no-repeat justify-center text-center bg-cover bg-fixed">
        <div className="text-center pt-80 text-neutral-110">
          <h4 className="tracking-wide text-2xl font-bold	 ">
            Ready to take your tech to the next level?
          </h4>
          <p>Build a winning cloud-based development team with MsCube Tech today.</p>
          <Link to="/contact">
          <button className="border-0 rounded-none btn btn-success font-bold text-white my-10 mx-10 px-4 py-2 bg-[#ce2e90]">Get Started</button>
        </Link>
        </div>
      </div>

    </div>
  );
}

export default Newsletter;
